<template>
  <div class="admission-query">
    <h2 class="title">录取查询</h2>

    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        class="query-form"
        @submit.native.prevent="onSubmit"
    >
      <!-- 年份（必填） -->
      <el-form-item label="年份" prop="year">
        <el-date-picker
            v-model="form.year"
            type="year"
            placeholder="请选择年份"
            value-format="yyyy"
            style="width: 100%"
        />
      </el-form-item>

      <!-- 姓名（必填） -->
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名" />
      </el-form-item>

      <!-- 身份证（必填） -->
      <el-form-item label="身份证" prop="idCard">
        <el-input v-model="form.idCard" placeholder="请输入身份证号" />
      </el-form-item>

      <!-- 考生号（必填） -->
      <el-form-item label="考生号" prop="examNo">
        <el-input v-model="form.examNo" placeholder="请输入考生号" />
      </el-form-item>

      <!-- 动态结果提示 -->
      <div v-if="result.show" class="result-tip" :class="result.type">
        {{ result.message }}
      </div>

      <div class="btns">
        <el-button type="primary" native-type="submit">查询</el-button>
        <el-button @click="onReset">清空</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'AdmissionQuery',
  data() {
    return {
      form: {
        year: '',
        name: '',
        idCard: '',
        examNo: ''
      },
      // 必填校验规则
      rules: {
        year: [
          { required: true, message: '请选择年份', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        examNo: [
          { required: true, message: '请输入考生号', trigger: 'blur' }
        ]
      },
      result: {
        show: false,
        type: '',
        message: ''
      }
    };
  },
  methods: {
    // 查询按钮
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return; // 校验不通过

        // 模拟查询（替换为真实接口）
        this.mockQuery()
            .then(res => {
              const data = res.data;
              if (data.admitted) {
                this.result = {
                  show: true,
                  type: 'success',
                  message: `录取成功! 当前录取专业为: ${data.major}`
                };
              } else {
                this.result = {
                  show: true,
                  type: 'error',
                  message: '未查询到录取信息'
                };
              }
            })
            .catch(() => {
              this.result = {
                show: true,
                type: 'error',
                message: '查询失败，请稍后重试'
              };
            });
      });
    },

    // 模拟接口（请替换为 axios.post）
    mockQuery() {
      return new Promise((resolve) => {
        setTimeout(() => {
          const random = Math.random();
          if (random > 0.3) {
            resolve({
              data: { admitted: true, major: '计算机科学与技术' }
            });
          } else {
            resolve({ data: { admitted: false } });
          }
        }, 600);
      });
    },

    // 清空表单 + 重置结果
    onReset() {
      this.$refs.form.resetFields();
      this.result = { show: false, type: '', message: '' };
    }
  }
};
</script>

<style scoped>
.admission-query {
  max-width: 460px;
  margin: 40px auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.title {
  text-align: center;
  margin-bottom: 30px;
  color: #303133;
}

.query-form .el-form-item {
  margin-bottom: 22px;
}

/* 必填星号为红色（Element UI 默认就是） */
.query-form .el-form-item.is-required .el-form-item__label::before {
  color: #f56c6c;
}

.result-tip {
  margin: 20px 0 30px;
  padding: 12px 16px;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
}

.result-tip.success {
  color: #67c23a;
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
}

.result-tip.error {
  color: #f56c6c;
  background-color: #fef0f0;
  border: 1px solid #fde2e2;
}

.btns {
  display: flex;
  justify-content: space-between;
}
</style>
